import React from 'react';
import PropTypes from 'prop-types'
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles((theme) => ({
   groupBox: {
      marginLeft: '5px',
      marginBottom: '5px',
      paddingBottom: '10px',
      paddingTop: '10px',
      paddingRight: '10px',
      paddingLeft: '10px',
      border: '1px solid lightgray',
      width: '100%'
   },
   groupBoxText: {
      verticalAlign: 'middle',
      textTransform: 'uppercase',
      marginTop: '-22px',
      backgroundColor: 'hsla(360, 0%, 100%, 0.36)',
      width: 'fit-content'
   }
}));
/**
 * Generar una caja con bordes para agrupar los componentes internos.
 */
function GroupBox(props) {
   const classes = useStyles();
   const { label, children } = props;
   return (
      <div className={clsx(classes.groupBox, props.className)}>
         <Typography className={clsx(classes.groupBoxText, props.classNameLabel)}>{label}</Typography>
         {children}
      </div>
   );
}
GroupBox.propTypes = {
   /**
    * Texto ha mostrar sobre la caja de grupo.
    */
   label: PropTypes.string
}
export default GroupBox;
